export default "__VITE_ASSET__DN5H_5Ka__"